/* ============================================================
   SIRCABLE — CART DRAWER BEHAVIOR
   Extracted from cart-drawer.liquid (was previously inline).
   Loaded via cart-drawer.liquid -> <script defer>.
   NOTE: open-cart trigger now targets the header cart icon
   by its id (#cart-link) instead of a Liquid-rendered href,
   so this file is pure JS with no Liquid dependency.
   ============================================================ */

  document.addEventListener('DOMContentLoaded', function() {

    // In Shopify theme editor, skip overlay + scroll lock so the editor
    // stays interactive. The drawer still opens/closes normally.
    const inDesignMode = !!(window.Shopify && window.Shopify.designMode);

    // ─── THE SCROLL MANAGER (delegates to the shared global lock) ───
    const ScrollManager = {
      lock:   function() { if (!inDesignMode) window.SircableScrollLock.lock('cart'); },
      unlock: function() { if (!inDesignMode) window.SircableScrollLock.unlock('cart'); }
    };

    window.addEventListener('pageshow', function(e) {
      if (e.persisted) window.SircableScrollLock.reset();
    });

    function openSircableCart() {
      const drawer = document.getElementById('sircable-cart-drawer');
      const overlay = document.getElementById('sircable-cart-overlay');
      if(drawer) drawer.classList.add('is-open');
      if(overlay && !inDesignMode) overlay.classList.add('is-active');
      ScrollManager.lock();
    }

    /* ── Drawer re-render, wallet-safe ──────────────────────────────
       Every cart mutation re-fetches the section and swaps it in. A plain
       innerHTML swap breaks Shopify's accelerated wallet buttons (Apple
       Pay / Google Pay / PayPal / Amazon Pay): <script> tags injected via
       innerHTML never execute, and the SDK's existing bindings die with
       the old DOM — leaving blank or dead buttons.

       Fix: lift the LIVE wallet node out before the swap, then graft it
       back over the fresh placeholder. Those buttons resolve the cart
       server-side at click time, so carrying the original node across a
       quantity change is still correct — it isn't showing a stale total.

       If the cart empties, the new markup has no placeholder and the old
       node is simply dropped, which is what we want. */
    function replaceCartDrawerHTML(newSectionEl) {
      const host = document.getElementById('shopify-section-cart-drawer');
      if (!host || !newSectionEl) return;

      const liveWallets = host.querySelector('#sircable-cart-wallets');
      host.innerHTML = newSectionEl.innerHTML;

      if (liveWallets) {
        const placeholder = host.querySelector('#sircable-cart-wallets');
        if (placeholder) placeholder.replaceWith(liveWallets);
      }
    }

    function closeSircableCart() {
      const drawer = document.getElementById('sircable-cart-drawer');
      const overlay = document.getElementById('sircable-cart-overlay');
      if(drawer) drawer.classList.remove('is-open');
      if(overlay) overlay.classList.remove('is-active');
      ScrollManager.unlock();
    }

    // ─── THE CART BUBBLE UPDATER (THE FIX) ───
    function updateCartBubble() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cart => {
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            bubble.textContent = cart.item_count;
            if (cart.item_count > 0) {
              bubble.style.display = 'flex';
            } else {
              bubble.style.display = 'none';
            }
          }
        })
        .catch((error) => console.error('Error fetching cart:', error));
    }

    // ─── EVENT DELEGATION BRAIN ───
    document.body.addEventListener('click', function(e) {
      
      // Close Actions
      if (e.target.closest('#sircable-cart-drawer-close') || e.target.closest('#sircable-cart-overlay')) {
        closeSircableCart();
      }

      // Open Actions
      const cartLink = e.target.closest('#cart-link, a[href="/cart"]');
      if (cartLink) {
        e.preventDefault();
        openSircableCart();
      }

      // Trash Can (Delete Item)
      const removeBtn = e.target.closest('.sircable-cart-remove');
      if (removeBtn) {
        e.preventDefault();
        if (removeBtn.disabled) return; 
        removeBtn.disabled = true;

        const lineItem = removeBtn.closest('.sircable-cart-item');
        const lineIndex = removeBtn.getAttribute('data-line');
        if (lineItem) lineItem.style.opacity = '0.4';

        const drawerEl = document.getElementById('sircable-cart-drawer');
        const wasOpenAtClick = drawerEl && drawerEl.classList.contains('is-open');

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity: 0 })
        })
        .then(() => fetch('/?section_id=cart-drawer'))
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newDrawerHTML = doc.getElementById('shopify-section-cart-drawer');
          
          if(newDrawerHTML) {
            const isCurrentlyOpen = document.getElementById('sircable-cart-drawer').classList.contains('is-open');
            replaceCartDrawerHTML(newDrawerHTML);
            
            if (wasOpenAtClick && isCurrentlyOpen) {
              openSircableCart(); 
            } else {
              closeSircableCart(); 
            }
            
            // FIRE THE UPDATER!
            updateCartBubble();
          }
        });
      }
      // Quantity +/- buttons
      const qtyBtn = e.target.closest('.sircable-cart-qty__btn');
      if (qtyBtn) {
        e.preventDefault();
        if (qtyBtn.disabled) return;
        qtyBtn.disabled = true;

        const lineIndex = qtyBtn.getAttribute('data-line');
        const newQty    = Math.max(0, parseInt(qtyBtn.getAttribute('data-qty'), 10));
        const lineItem  = qtyBtn.closest('.sircable-cart-item');
        const drawerEl  = document.getElementById('sircable-cart-drawer');
        const wasOpen   = drawerEl && drawerEl.classList.contains('is-open');

        if (lineItem) lineItem.style.opacity = '0.4';

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity: newQty })
        })
        .then(() => fetch('/?section_id=cart-drawer'))
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newDrawerHTML = doc.getElementById('shopify-section-cart-drawer');
          if (newDrawerHTML) {
            const isOpen = document.getElementById('sircable-cart-drawer').classList.contains('is-open');
            replaceCartDrawerHTML(newDrawerHTML);
            wasOpen && isOpen ? openSircableCart() : closeSircableCart();
            updateCartBubble();
          }
        })
        .catch(() => { qtyBtn.disabled = false; });
      }

    });

    // ─── ADD TO CART INTERCEPTOR ───
    const productForm = document.getElementById('product-form');
    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault(); 
        
        const atcButton = document.getElementById('add-to-cart-button');
        const originalText = atcButton.innerHTML;
        atcButton.innerHTML = 'ADDING...';
        atcButton.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(productForm)
        })
        .then(response => {
          if(!response.ok) throw new Error('Network response was not ok');
          return fetch('/?section_id=cart-drawer'); 
        })
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newDrawerHTML = doc.getElementById('shopify-section-cart-drawer');
          
          if (newDrawerHTML) {
            replaceCartDrawerHTML(newDrawerHTML);
            openSircableCart();
            
            // FIRE THE UPDATER!
            updateCartBubble();
          } else {
            window.location.href = '/cart'; 
          }
        })
        .catch(err => { window.location.href = '/cart'; })
        .finally(() => {
          atcButton.innerHTML = originalText;
          atcButton.disabled = false;
        });
      });
    }
  });